[
	{
		"want": "a wooden treasure chest with iron bands",
		"view": "front",
		"spec": {
			"name": "treasure_chest",
			"size": [
				40,
				32
			],
			"kit": {
				"name": "chest_kit",
				"roles": {
					"none": [
						0,
						0,
						0,
						0
					],
					"outline": [
						26,
						15,
						10,
						255
					],
					"wood": [
						124,
						74,
						38,
						255
					],
					"wood_lit": [
						160,
						102,
						56,
						255
					],
					"wood_dark": [
						86,
						49,
						24,
						255
					],
					"iron": [
						92,
						92,
						102,
						255
					],
					"iron_lit": [
						136,
						138,
						148,
						255
					],
					"iron_dark": [
						52,
						52,
						60,
						255
					],
					"brass": [
						176,
						134,
						52,
						255
					],
					"brass_lit": [
						214,
						180,
						92,
						255
					],
					"brass_dark": [
						112,
						82,
						30,
						255
					],
					"hole": [
						20,
						14,
						12,
						255
					]
				}
			},
			"outline": true,
			"parts": [
				{
					"shape": "taper",
					"inset": [
						1,
						2,
						1,
						20
					],
					"role": "wood",
					"litRole": "wood_lit",
					"shadeRole": "wood_dark",
					"narrow": 0.86,
					"towards": "top"
				},
				{
					"shape": "panel",
					"inset": [
						1,
						12,
						1,
						2
					],
					"role": "wood",
					"borderRole": "wood_dark"
				},
				{
					"shape": "grille",
					"inset": [
						2,
						14,
						2,
						3
					],
					"step": 5,
					"role": "wood_dark",
					"gapRole": "none",
					"direction": "rows"
				},
				{
					"shape": "panel",
					"inset": [
						1,
						10,
						1,
						20
					],
					"role": "iron",
					"borderRole": "iron_dark"
				},
				{
					"shape": "panel",
					"inset": [
						1,
						10,
						1,
						21
					],
					"role": "iron_lit",
					"borderRole": "none"
				},
				{
					"shape": "panel",
					"inset": [
						5,
						3,
						32,
						2
					],
					"role": "iron",
					"borderRole": "iron_dark"
				},
				{
					"shape": "panel",
					"inset": [
						5,
						3,
						34,
						2
					],
					"role": "iron_lit",
					"borderRole": "none"
				},
				{
					"shape": "panel",
					"inset": [
						31,
						3,
						6,
						2
					],
					"role": "iron",
					"borderRole": "iron_dark"
				},
				{
					"shape": "panel",
					"inset": [
						31,
						3,
						8,
						2
					],
					"role": "iron_lit",
					"borderRole": "none"
				},
				{
					"shape": "panel",
					"inset": [
						1,
						28,
						1,
						2
					],
					"role": "iron",
					"borderRole": "iron_dark"
				},
				{
					"shape": "rivets",
					"inset": [
						5,
						4,
						32,
						3
					],
					"along": "left",
					"step": 5,
					"role": "iron_lit"
				},
				{
					"shape": "rivets",
					"inset": [
						31,
						4,
						6,
						3
					],
					"along": "left",
					"step": 5,
					"role": "iron_lit"
				},
				{
					"shape": "panel",
					"inset": [
						16,
						8,
						16,
						9
					],
					"role": "brass",
					"borderRole": "brass_dark"
				},
				{
					"shape": "panel",
					"inset": [
						16,
						8,
						17,
						10
					],
					"role": "brass_lit",
					"borderRole": "none"
				},
				{
					"shape": "rivets",
					"inset": [
						17,
						9,
						17,
						10
					],
					"along": "top",
					"step": 4,
					"role": "brass_dark"
				},
				{
					"shape": "disc",
					"inset": [
						19,
						15,
						19,
						13
					],
					"role": "hole",
					"borderRole": "brass_dark",
					"litRole": "none"
				},
				{
					"shape": "panel",
					"inset": [
						19,
						17,
						19,
						11
					],
					"role": "hole",
					"borderRole": "none"
				},
				{
					"shape": "panel",
					"inset": [
						2,
						30,
						32,
						0
					],
					"role": "iron_dark",
					"borderRole": "none"
				},
				{
					"shape": "panel",
					"inset": [
						32,
						30,
						2,
						0
					],
					"role": "iron_dark",
					"borderRole": "none"
				}
			]
		}
	},
	{
		"want": "a street lantern with a flickering flame",
		"view": "front",
		"spec": {
			"name": "street_lantern",
			"size": [
				32,
				48
			],
			"kit": {
				"name": "iron_lantern",
				"roles": {
					"none": [
						0,
						0,
						0,
						0
					],
					"outline": [
						16,
						14,
						18,
						255
					],
					"iron": [
						64,
						62,
						72,
						255
					],
					"iron_lit": [
						98,
						96,
						108,
						255
					],
					"iron_dark": [
						38,
						36,
						44,
						255
					],
					"brass": [
						148,
						112,
						52,
						255
					],
					"brass_lit": [
						196,
						158,
						82,
						255
					],
					"chamber": [
						46,
						40,
						36,
						255
					],
					"chamber_lit": [
						72,
						62,
						52,
						255
					],
					"flame_dark": [
						176,
						72,
						20,
						255
					],
					"flame": [
						240,
						150,
						40,
						255
					],
					"flame_lit": [
						255,
						226,
						130,
						255
					],
					"glow": [
						255,
						170,
						60,
						90
					],
					"glass": [
						186,
						214,
						220,
						70
					]
				},
				"required": [
					"none",
					"outline"
				]
			},
			"frames": {
				"count": 6,
				"drive": "flicker",
				"curve": "pulse",
				"values": [
					0.95,
					0.62,
					1,
					0.72,
					0.86,
					0.55
				]
			},
			"outline": true,
			"parts": [
				{
					"shape": "ring",
					"inset": [
						12,
						0,
						12,
						43
					],
					"role": "iron",
					"thickness": 1
				},
				{
					"shape": "taper",
					"inset": [
						3,
						4,
						3,
						38
					],
					"role": "iron",
					"litRole": "iron_lit",
					"shadeRole": "iron_dark",
					"narrow": 0.28,
					"towards": "top"
				},
				{
					"shape": "panel",
					"inset": [
						4,
						10,
						4,
						36
					],
					"role": "iron_lit",
					"borderRole": "iron_dark"
				},
				{
					"shape": "casing",
					"inset": [
						5,
						12,
						5,
						14
					],
					"role": "iron",
					"lit": "iron_lit",
					"shadow": "iron_dark",
					"bevel": "left",
					"bevelWidth": 2,
					"lipHeight": 1,
					"lipRole": "brass",
					"accentRole": "none"
				},
				{
					"shape": "panel",
					"inset": [
						7,
						14,
						7,
						16
					],
					"role": "chamber",
					"borderRole": "iron_dark"
				},
				{
					"shape": "gradient",
					"inset": [
						8,
						15,
						8,
						17
					],
					"from": "chamber",
					"to": "chamber_lit",
					"bands": 3
				},
				{
					"shape": "disc",
					"inset": [
						8,
						17,
						8,
						18
					],
					"role": "glow",
					"borderRole": "none",
					"litRole": "none"
				},
				{
					"shape": "lamp",
					"at": [
						13,
						26
					],
					"size": [
						6,
						3
					],
					"value": "flicker",
					"thresholds": [
						0.2,
						0.6
					],
					"roles": [
						"flame_dark",
						"flame",
						"flame_lit"
					],
					"highlight": false
				},
				{
					"shape": "glyph",
					"id": "flame",
					"at": [
						12,
						19
					],
					"role": "flame",
					"value": "flicker",
					"thresholds": [
						0.35,
						0.8
					],
					"roles": [
						"flame_dark",
						"flame",
						"flame_lit"
					]
				},
				{
					"shape": "glass",
					"inset": [
						7,
						14,
						7,
						16
					],
					"role": "glass",
					"glintRole": "flame_lit"
				},
				{
					"shape": "panel",
					"inset": [
						7,
						14,
						24,
						16
					],
					"role": "iron_lit",
					"borderRole": "none"
				},
				{
					"shape": "panel",
					"inset": [
						24,
						14,
						7,
						16
					],
					"role": "iron_dark",
					"borderRole": "none"
				},
				{
					"shape": "panel",
					"inset": [
						7,
						22,
						7,
						25
					],
					"role": "iron_dark",
					"borderRole": "none"
				},
				{
					"shape": "rivets",
					"inset": [
						6,
						13,
						6,
						34
					],
					"along": "top",
					"step": 5,
					"role": "brass_lit"
				},
				{
					"shape": "panel",
					"inset": [
						4,
						34,
						4,
						11
					],
					"role": "iron",
					"borderRole": "iron_dark"
				},
				{
					"shape": "panel",
					"inset": [
						4,
						34,
						4,
						13
					],
					"role": "brass",
					"borderRole": "none"
				},
				{
					"shape": "taper",
					"inset": [
						6,
						37,
						6,
						5
					],
					"role": "iron",
					"litRole": "iron_lit",
					"shadeRole": "iron_dark",
					"narrow": 0.45,
					"towards": "bottom"
				},
				{
					"shape": "panel",
					"inset": [
						3,
						43,
						3,
						1
					],
					"role": "iron",
					"borderRole": "iron_dark"
				},
				{
					"shape": "panel",
					"inset": [
						3,
						43,
						3,
						3
					],
					"role": "iron_lit",
					"borderRole": "none"
				}
			]
		}
	},
	{
		"want": "a glass potion bottle with glowing green liquid",
		"view": "front",
		"spec": {
			"name": "glass_potion_bottle",
			"size": [
				32,
				48
			],
			"kit": {
				"name": "alchemy_glass",
				"roles": {
					"none": [
						0,
						0,
						0,
						0
					],
					"outline": [
						18,
						26,
						22,
						255
					],
					"glass": [
						92,
						128,
						116,
						255
					],
					"glass_lit": [
						150,
						190,
						178,
						255
					],
					"glass_dark": [
						52,
						78,
						72,
						255
					],
					"chamber": [
						46,
						66,
						60,
						255
					],
					"chamber_lit": [
						72,
						98,
						90,
						255
					],
					"liquid": [
						58,
						196,
						84,
						255
					],
					"liquid_lit": [
						138,
						246,
						140,
						255
					],
					"liquid_dark": [
						24,
						122,
						60,
						255
					],
					"glow": [
						190,
						255,
						170,
						190
					],
					"sheet": [
						170,
						210,
						200,
						90
					],
					"shine": [
						235,
						255,
						250,
						150
					],
					"cork": [
						156,
						112,
						62,
						255
					],
					"cork_lit": [
						200,
						156,
						98,
						255
					],
					"cork_dark": [
						104,
						70,
						38,
						255
					],
					"rim": [
						70,
						96,
						90,
						255
					]
				},
				"ramps": {
					"charge": [
						"liquid_dark",
						"liquid",
						"liquid_lit"
					]
				}
			},
			"frames": {
				"count": 6,
				"drive": "pulse",
				"curve": "pulse"
			},
			"outline": "outline",
			"parts": [
				{
					"shape": "panel",
					"inset": [
						12,
						5,
						12,
						32
					],
					"role": "glass",
					"borderRole": "glass_dark"
				},
				{
					"shape": "taper",
					"inset": [
						4,
						14,
						4,
						26
					],
					"role": "glass",
					"litRole": "glass_lit",
					"shadeRole": "glass_dark",
					"narrow": 0.35,
					"towards": "top"
				},
				{
					"shape": "panel",
					"inset": [
						4,
						20,
						4,
						2
					],
					"role": "glass",
					"borderRole": "glass_dark"
				},
				{
					"shape": "level",
					"inset": [
						6,
						22,
						6,
						4
					],
					"value": 0.78,
					"role": "liquid",
					"surfaceRole": "liquid_lit",
					"depthRole": "liquid_dark",
					"emptyRole": "chamber",
					"emptyLitRole": "chamber_lit",
					"sheen": "left",
					"bubbles": true
				},
				{
					"shape": "panel",
					"inset": [
						14,
						12,
						14,
						34
					],
					"role": "liquid_dark",
					"borderRole": "none"
				},
				{
					"shape": "casing",
					"inset": [
						12,
						2,
						12,
						42
					],
					"role": "cork",
					"lit": "cork_lit",
					"shadow": "cork_dark",
					"bevel": "left",
					"bevelWidth": 2,
					"lipHeight": 1,
					"lipRole": "cork_lit",
					"accentRole": "none"
				},
				{
					"shape": "border",
					"inset": [
						11,
						14,
						11,
						32
					],
					"role": "rim"
				},
				{
					"shape": "glass",
					"inset": [
						5,
						21,
						5,
						3
					],
					"role": "sheet",
					"glintRole": "none"
				},
				{
					"shape": "glass",
					"inset": [
						13,
						6,
						13,
						33
					],
					"role": "sheet",
					"glintRole": "none"
				},
				{
					"shape": "panel",
					"inset": [
						7,
						24,
						22,
						12
					],
					"role": "shine",
					"borderRole": "none"
				},
				{
					"shape": "panel",
					"inset": [
						13,
						8,
						17,
						35
					],
					"role": "shine",
					"borderRole": "none"
				},
				{
					"shape": "lamp",
					"at": [
						12,
						32
					],
					"size": [
						8,
						6
					],
					"value": "pulse",
					"thresholds": [
						0.2,
						0.55
					],
					"roles": [
						"liquid_dark",
						"liquid",
						"glow"
					],
					"highlight": false
				},
				{
					"shape": "lamp",
					"at": [
						14,
						40
					],
					"size": [
						5,
						3
					],
					"value": "pulse",
					"thresholds": [
						0.3,
						0.7
					],
					"roles": [
						"liquid_dark",
						"liquid",
						"liquid_lit"
					],
					"highlight": false
				},
				{
					"shape": "lamp",
					"at": [
						14,
						15
					],
					"size": [
						4,
						2
					],
					"value": "pulse",
					"thresholds": [
						0.25,
						0.6
					],
					"roles": [
						"liquid_dark",
						"liquid",
						"glow"
					],
					"highlight": false
				}
			]
		}
	},
	{
		"want": "a wooden barrel bound with iron hoops",
		"view": "three-quarter",
		"spec": {
			"name": "wooden_barrel",
			"size": [
				32,
				40
			],
			"kit": {
				"name": "oak_and_iron",
				"roles": {
					"none": [
						0,
						0,
						0,
						0
					],
					"outline": [
						38,
						23,
						12,
						255
					],
					"wood": [
						140,
						94,
						54,
						255
					],
					"wood_lit": [
						178,
						128,
						78,
						255
					],
					"wood_dark": [
						98,
						62,
						34,
						255
					],
					"wood_seam": [
						80,
						50,
						27,
						255
					],
					"wood_top": [
						156,
						110,
						66,
						255
					],
					"wood_top_lit": [
						190,
						142,
						92,
						255
					],
					"iron": [
						104,
						108,
						116,
						255
					],
					"iron_lit": [
						150,
						155,
						164,
						255
					],
					"iron_dark": [
						58,
						60,
						68,
						255
					],
					"rivet_lit": [
						176,
						180,
						188,
						255
					]
				}
			},
			"outline": "outline",
			"parts": [
				{
					"shape": "casing",
					"inset": [
						2,
						9,
						2,
						1
					],
					"role": "wood",
					"lit": "wood_lit",
					"shadow": "wood_dark",
					"bevel": "left",
					"bevelWidth": 3,
					"lipHeight": 0,
					"lipRole": "iron",
					"accentRole": "none"
				},
				{
					"shape": "grille",
					"inset": [
						3,
						10,
						3,
						2
					],
					"step": 4,
					"role": "wood_seam",
					"gapRole": "none",
					"direction": "columns"
				},
				{
					"shape": "panel",
					"inset": [
						1,
						10,
						1,
						27
					],
					"role": "iron",
					"borderRole": "iron_dark"
				},
				{
					"shape": "panel",
					"inset": [
						1,
						21,
						1,
						16
					],
					"role": "iron",
					"borderRole": "iron_dark"
				},
				{
					"shape": "panel",
					"inset": [
						1,
						33,
						1,
						4
					],
					"role": "iron",
					"borderRole": "iron_dark"
				},
				{
					"shape": "panel",
					"inset": [
						2,
						10,
						24,
						27
					],
					"role": "iron_lit",
					"borderRole": "none"
				},
				{
					"shape": "panel",
					"inset": [
						2,
						21,
						24,
						16
					],
					"role": "iron_lit",
					"borderRole": "none"
				},
				{
					"shape": "panel",
					"inset": [
						2,
						33,
						24,
						4
					],
					"role": "iron_lit",
					"borderRole": "none"
				},
				{
					"shape": "rivets",
					"inset": [
						3,
						11,
						3,
						27
					],
					"along": "top",
					"step": 6,
					"role": "rivet_lit"
				},
				{
					"shape": "rivets",
					"inset": [
						3,
						34,
						3,
						4
					],
					"along": "top",
					"step": 6,
					"role": "rivet_lit"
				},
				{
					"shape": "disc",
					"inset": [
						2,
						2,
						2,
						29
					],
					"role": "wood_top",
					"borderRole": "iron_dark",
					"litRole": "wood_top_lit"
				},
				{
					"shape": "ring",
					"inset": [
						3,
						3,
						3,
						30
					],
					"role": "iron",
					"thickness": 1
				},
				{
					"shape": "disc",
					"inset": [
						13,
						5,
						13,
						32
					],
					"role": "wood_dark",
					"borderRole": "wood_seam",
					"litRole": "none"
				}
			]
		}
	},
	{
		"want": "a stone well with a wooden bucket",
		"view": "three-quarter",
		"spec": {
			"name": "stone_well",
			"size": [
				40,
				48
			],
			"kit": {
				"name": "well_kit",
				"roles": {
					"none": [
						0,
						0,
						0,
						0
					],
					"outline": [
						30,
						26,
						24,
						255
					],
					"stone": [
						122,
						120,
						112,
						255
					],
					"stone_lit": [
						152,
						150,
						140,
						255
					],
					"stone_dark": [
						86,
						84,
						78,
						255
					],
					"stone_darkest": [
						58,
						56,
						52,
						255
					],
					"moss": [
						92,
						118,
						70,
						255
					],
					"water": [
						38,
						64,
						88,
						255
					],
					"water_lit": [
						64,
						98,
						126,
						255
					],
					"wood": [
						136,
						94,
						54,
						255
					],
					"wood_lit": [
						172,
						126,
						76,
						255
					],
					"wood_dark": [
						92,
						60,
						34,
						255
					],
					"rope": [
						186,
						164,
						112,
						255
					],
					"band": [
						112,
						112,
						120,
						255
					],
					"band_lit": [
						146,
						146,
						152,
						255
					]
				}
			},
			"outline": true,
			"parts": [
				{
					"shape": "casing",
					"inset": [
						4,
						22,
						4,
						1
					],
					"role": "stone",
					"lit": "stone_lit",
					"shadow": "stone_dark",
					"bevel": "left",
					"bevelWidth": 3,
					"lipHeight": 0,
					"lipRole": "stone_lit",
					"accentRole": "none"
				},
				{
					"shape": "grille",
					"inset": [
						6,
						26,
						6,
						4
					],
					"step": 5,
					"role": "stone_dark",
					"gapRole": "none",
					"direction": "rows"
				},
				{
					"shape": "panel",
					"inset": [
						5,
						40,
						22,
						3
					],
					"role": "moss",
					"borderRole": "none"
				},
				{
					"shape": "disc",
					"inset": [
						2,
						16,
						2,
						20
					],
					"role": "stone",
					"borderRole": "outline",
					"litRole": "stone_lit"
				},
				{
					"shape": "disc",
					"inset": [
						7,
						19,
						7,
						23
					],
					"role": "water",
					"borderRole": "stone_darkest",
					"litRole": "water_lit"
				},
				{
					"shape": "panel",
					"inset": [
						6,
						3,
						31,
						25
					],
					"role": "wood",
					"borderRole": "wood_dark"
				},
				{
					"shape": "panel",
					"inset": [
						30,
						3,
						7,
						25
					],
					"role": "wood",
					"borderRole": "wood_dark"
				},
				{
					"shape": "panel",
					"inset": [
						4,
						1,
						4,
						43
					],
					"role": "wood",
					"borderRole": "wood_dark"
				},
				{
					"shape": "panel",
					"inset": [
						4,
						1,
						4,
						46
					],
					"role": "wood_lit",
					"borderRole": "none"
				},
				{
					"shape": "panel",
					"inset": [
						19,
						5,
						19,
						31
					],
					"role": "rope",
					"borderRole": "none"
				},
				{
					"shape": "taper",
					"inset": [
						15,
						16,
						15,
						22
					],
					"role": "wood",
					"litRole": "wood_lit",
					"shadeRole": "wood_dark",
					"narrow": 0.78,
					"towards": "bottom"
				},
				{
					"shape": "panel",
					"inset": [
						15,
						16,
						15,
						30
					],
					"role": "band_lit",
					"borderRole": "outline"
				},
				{
					"shape": "panel",
					"inset": [
						16,
						23,
						16,
						24
					],
					"role": "band",
					"borderRole": "none"
				}
			]
		}
	},
	{
		"want": "a market stall with a striped awning",
		"view": "three-quarter",
		"spec": {
			"name": "market_stall",
			"size": [
				48,
				48
			],
			"kit": {
				"name": "market_stall_kit",
				"roles": {
					"none": [
						0,
						0,
						0,
						0
					],
					"outline": [
						40,
						26,
						18,
						255
					],
					"canvas_red": [
						186,
						58,
						52,
						255
					],
					"canvas_red_dark": [
						140,
						40,
						38,
						255
					],
					"canvas_cream": [
						232,
						218,
						186,
						255
					],
					"canvas_cream_lit": [
						248,
						240,
						216,
						255
					],
					"canvas_shade": [
						150,
						122,
						100,
						255
					],
					"wood": [
						140,
						96,
						56,
						255
					],
					"wood_lit": [
						176,
						130,
						82,
						255
					],
					"wood_dark": [
						102,
						68,
						40,
						255
					],
					"wood_darkest": [
						72,
						48,
						28,
						255
					],
					"crate": [
						158,
						116,
						70,
						255
					],
					"crate_dark": [
						104,
						72,
						42,
						255
					],
					"apple": [
						190,
						62,
						54,
						255
					],
					"apple_lit": [
						226,
						106,
						88,
						255
					],
					"green": [
						86,
						140,
						62,
						255
					],
					"green_lit": [
						128,
						178,
						88,
						255
					]
				}
			},
			"outline": true,
			"parts": [
				{
					"shape": "panel",
					"inset": [
						4,
						15,
						41,
						15
					],
					"role": "wood_dark",
					"borderRole": "wood_darkest"
				},
				{
					"shape": "panel",
					"inset": [
						41,
						15,
						4,
						15
					],
					"role": "wood_dark",
					"borderRole": "wood_darkest"
				},
				{
					"shape": "panel",
					"inset": [
						2,
						3,
						2,
						31
					],
					"role": "canvas_cream",
					"borderRole": "canvas_shade"
				},
				{
					"shape": "grille",
					"inset": [
						2,
						5,
						2,
						31
					],
					"step": 4,
					"role": "canvas_red",
					"gapRole": "canvas_cream",
					"direction": "columns"
				},
				{
					"shape": "panel",
					"inset": [
						2,
						3,
						2,
						43
					],
					"role": "canvas_cream_lit",
					"borderRole": "canvas_shade"
				},
				{
					"shape": "studs",
					"inset": [
						2,
						3,
						2,
						31
					],
					"along": "bottom",
					"step": 4,
					"size": [
						2,
						2
					],
					"role": "canvas_red_dark"
				},
				{
					"shape": "panel",
					"inset": [
						7,
						19,
						29,
						22
					],
					"role": "crate",
					"borderRole": "crate_dark"
				},
				{
					"shape": "panel",
					"inset": [
						28,
						19,
						8,
						22
					],
					"role": "crate",
					"borderRole": "crate_dark"
				},
				{
					"shape": "disc",
					"inset": [
						8,
						16,
						36,
						29
					],
					"role": "apple",
					"borderRole": "wood_darkest",
					"litRole": "apple_lit"
				},
				{
					"shape": "disc",
					"inset": [
						13,
						16,
						31,
						29
					],
					"role": "apple",
					"borderRole": "wood_darkest",
					"litRole": "apple_lit"
				},
				{
					"shape": "disc",
					"inset": [
						30,
						16,
						14,
						29
					],
					"role": "green",
					"borderRole": "wood_darkest",
					"litRole": "green_lit"
				},
				{
					"shape": "disc",
					"inset": [
						35,
						16,
						9,
						29
					],
					"role": "green",
					"borderRole": "wood_darkest",
					"litRole": "green_lit"
				},
				{
					"shape": "panel",
					"inset": [
						3,
						26,
						3,
						17
					],
					"role": "wood_lit",
					"borderRole": "wood_dark"
				},
				{
					"shape": "casing",
					"inset": [
						4,
						31,
						4,
						2
					],
					"role": "wood",
					"lit": "wood_lit",
					"shadow": "wood_dark",
					"bevel": "left",
					"bevelWidth": 2,
					"lipHeight": 1,
					"lipRole": "wood_lit",
					"accentRole": "none"
				},
				{
					"shape": "grille",
					"inset": [
						6,
						33,
						6,
						4
					],
					"step": 6,
					"role": "wood_dark",
					"gapRole": "none",
					"direction": "columns"
				}
			]
		}
	},
	{
		"want": "a round patterned rug",
		"view": "top-down",
		"spec": {
			"name": "round_patterned_rug",
			"size": [
				40,
				40
			],
			"kit": {
				"name": "woven_rug",
				"roles": {
					"none": [
						0,
						0,
						0,
						0
					],
					"outline": [
						38,
						18,
						22,
						255
					],
					"rug": [
						150,
						44,
						46,
						255
					],
					"rug_lit": [
						182,
						66,
						62,
						255
					],
					"rug_dark": [
						104,
						30,
						36,
						255
					],
					"cream": [
						232,
						214,
						178,
						255
					],
					"cream_dark": [
						190,
						168,
						130,
						255
					],
					"gold": [
						206,
						158,
						62,
						255
					],
					"gold_lit": [
						234,
						194,
						104,
						255
					],
					"navy": [
						46,
						56,
						92,
						255
					],
					"navy_lit": [
						72,
						86,
						128,
						255
					]
				}
			},
			"outline": "outline",
			"parts": [
				{
					"shape": "disc",
					"inset": [
						0,
						0,
						0,
						0
					],
					"role": "rug_dark",
					"borderRole": "outline",
					"litRole": "none"
				},
				{
					"shape": "disc",
					"inset": [
						2,
						2,
						2,
						2
					],
					"role": "rug",
					"borderRole": "rug_dark",
					"litRole": "rug_lit"
				},
				{
					"shape": "ring",
					"inset": [
						4,
						4,
						4,
						4
					],
					"role": "cream",
					"thickness": 1
				},
				{
					"shape": "ring",
					"inset": [
						6,
						6,
						6,
						6
					],
					"role": "gold",
					"thickness": 2
				},
				{
					"shape": "disc",
					"inset": [
						9,
						9,
						9,
						9
					],
					"role": "navy",
					"borderRole": "cream_dark",
					"litRole": "navy_lit"
				},
				{
					"shape": "ring",
					"inset": [
						12,
						12,
						12,
						12
					],
					"role": "cream",
					"thickness": 1
				},
				{
					"shape": "disc",
					"inset": [
						14,
						14,
						14,
						14
					],
					"role": "rug",
					"borderRole": "rug_dark",
					"litRole": "rug_lit"
				},
				{
					"shape": "ring",
					"inset": [
						16,
						16,
						16,
						16
					],
					"role": "gold",
					"thickness": 1
				},
				{
					"shape": "glyph",
					"id": "spark",
					"at": [
						17,
						17
					],
					"role": "gold_lit",
					"value": 1,
					"thresholds": [
						0.25,
						0.75
					],
					"roles": []
				},
				{
					"shape": "studs",
					"inset": [
						7,
						10,
						7,
						10
					],
					"along": "top",
					"step": 6,
					"size": [
						2,
						2
					],
					"role": "cream"
				},
				{
					"shape": "studs",
					"inset": [
						7,
						10,
						7,
						10
					],
					"along": "bottom",
					"step": 6,
					"size": [
						2,
						2
					],
					"role": "cream"
				},
				{
					"shape": "studs",
					"inset": [
						10,
						7,
						10,
						7
					],
					"along": "left",
					"step": 6,
					"size": [
						2,
						2
					],
					"role": "cream"
				},
				{
					"shape": "studs",
					"inset": [
						10,
						7,
						10,
						7
					],
					"along": "right",
					"step": 6,
					"size": [
						2,
						2
					],
					"role": "cream"
				},
				{
					"shape": "ring",
					"inset": [
						1,
						1,
						1,
						1
					],
					"role": "cream_dark",
					"thickness": 1
				}
			]
		}
	},
	{
		"want": "a wooden dining table set for one",
		"view": "top-down",
		"spec": {
			"name": "dining_table_set_for_one",
			"size": [
				48,
				32
			],
			"kit": {
				"name": "oak_supper",
				"roles": {
					"none": [
						0,
						0,
						0,
						0
					],
					"outline": [
						38,
						24,
						14,
						255
					],
					"wood": [
						140,
						94,
						52,
						255
					],
					"wood_lit": [
						170,
						121,
						72,
						255
					],
					"wood_dark": [
						104,
						67,
						36,
						255
					],
					"wood_seam": [
						88,
						55,
						29,
						255
					],
					"plate": [
						226,
						224,
						214,
						255
					],
					"plate_lit": [
						246,
						245,
						240,
						255
					],
					"plate_dark": [
						176,
						172,
						162,
						255
					],
					"food": [
						178,
						96,
						60,
						255
					],
					"food_dark": [
						132,
						66,
						40,
						255
					],
					"metal": [
						162,
						168,
						176,
						255
					],
					"metal_lit": [
						214,
						219,
						225,
						255
					],
					"metal_dark": [
						104,
						110,
						120,
						255
					],
					"cloth": [
						166,
						78,
						76,
						255
					],
					"cloth_dark": [
						122,
						52,
						52,
						255
					],
					"glass_rim": [
						198,
						214,
						216,
						255
					],
					"water": [
						110,
						168,
						190,
						140
					]
				}
			},
			"outline": true,
			"parts": [
				{
					"shape": "casing",
					"inset": [
						0,
						0,
						0,
						0
					],
					"role": "wood",
					"lit": "wood_lit",
					"shadow": "wood_dark",
					"bevel": "left",
					"bevelWidth": 2,
					"lipHeight": 0,
					"lipRole": "wood_dark",
					"accentRole": "none"
				},
				{
					"shape": "grille",
					"inset": [
						2,
						2,
						2,
						2
					],
					"step": 7,
					"role": "wood_seam",
					"gapRole": "none",
					"direction": "columns"
				},
				{
					"shape": "border",
					"inset": [
						1,
						1,
						1,
						1
					],
					"role": "wood_dark"
				},
				{
					"shape": "panel",
					"inset": [
						4,
						9,
						40,
						9
					],
					"role": "cloth",
					"borderRole": "cloth_dark"
				},
				{
					"shape": "pipe",
					"from": [
						12,
						11
					],
					"to": [
						12,
						23
					],
					"width": 2,
					"role": "metal",
					"litRole": "metal_lit"
				},
				{
					"shape": "panel",
					"inset": [
						10,
						8,
						36,
						21
					],
					"role": "metal_lit",
					"borderRole": "metal_dark"
				},
				{
					"shape": "pipe",
					"from": [
						35,
						11
					],
					"to": [
						35,
						23
					],
					"width": 2,
					"role": "metal",
					"litRole": "metal_lit"
				},
				{
					"shape": "panel",
					"inset": [
						33,
						8,
						13,
						20
					],
					"role": "metal_lit",
					"borderRole": "metal_dark"
				},
				{
					"shape": "disc",
					"inset": [
						16,
						8,
						16,
						8
					],
					"role": "plate",
					"borderRole": "plate_dark",
					"litRole": "plate_lit"
				},
				{
					"shape": "ring",
					"inset": [
						19,
						11,
						19,
						11
					],
					"role": "plate_dark",
					"thickness": 1
				},
				{
					"shape": "disc",
					"inset": [
						21,
						13,
						21,
						13
					],
					"role": "food",
					"borderRole": "food_dark",
					"litRole": "plate_lit"
				},
				{
					"shape": "disc",
					"inset": [
						37,
						3,
						4,
						22
					],
					"role": "glass_rim",
					"borderRole": "metal_dark",
					"litRole": "plate_lit"
				},
				{
					"shape": "disc",
					"inset": [
						38,
						4,
						5,
						23
					],
					"role": "water",
					"borderRole": "none",
					"litRole": "none"
				}
			]
		}
	},
	{
		"want": "a campfire ringed with stones",
		"view": "top-down",
		"spec": {
			"name": "campfire_stone_ring",
			"size": [
				32,
				32
			],
			"kit": {
				"name": "campfire_topdown",
				"roles": {
					"none": [
						0,
						0,
						0,
						0
					],
					"outline": [
						26,
						20,
						18,
						255
					],
					"white": [
						255,
						250,
						232,
						255
					],
					"stone": [
						122,
						122,
						126,
						255
					],
					"stone_lit": [
						163,
						164,
						168,
						255
					],
					"stone_dark": [
						82,
						82,
						88,
						255
					],
					"ash": [
						76,
						68,
						64,
						255
					],
					"ash_lit": [
						104,
						94,
						88,
						255
					],
					"ash_dark": [
						50,
						44,
						42,
						255
					],
					"log": [
						96,
						66,
						40,
						255
					],
					"log_lit": [
						130,
						92,
						56,
						255
					],
					"log_dark": [
						62,
						42,
						26,
						255
					],
					"ember": [
						190,
						72,
						26,
						255
					],
					"flame_dark": [
						204,
						92,
						24,
						255
					],
					"flame": [
						240,
						148,
						34,
						255
					],
					"flame_lit": [
						252,
						218,
						108,
						255
					],
					"spark": [
						255,
						236,
						170,
						255
					]
				},
				"ramps": {
					"fire": [
						"flame_dark",
						"flame",
						"flame_lit"
					]
				}
			},
			"frames": {
				"count": 6,
				"drive": "flicker",
				"curve": "pulse",
				"values": [
					0.45,
					0.8,
					1,
					0.7,
					0.35,
					0.6
				]
			},
			"outline": "outline",
			"parts": [
				{
					"shape": "disc",
					"inset": [
						1,
						1,
						1,
						1
					],
					"role": "stone",
					"borderRole": "outline",
					"litRole": "stone_lit"
				},
				{
					"shape": "studs",
					"inset": [
						2,
						2,
						2,
						2
					],
					"along": "top",
					"step": 5,
					"size": [
						3,
						2
					],
					"role": "stone_lit"
				},
				{
					"shape": "studs",
					"inset": [
						2,
						2,
						2,
						2
					],
					"along": "left",
					"step": 5,
					"size": [
						2,
						3
					],
					"role": "stone_lit"
				},
				{
					"shape": "studs",
					"inset": [
						2,
						2,
						2,
						2
					],
					"along": "bottom",
					"step": 5,
					"size": [
						3,
						2
					],
					"role": "stone_dark"
				},
				{
					"shape": "studs",
					"inset": [
						2,
						2,
						2,
						2
					],
					"along": "right",
					"step": 5,
					"size": [
						2,
						3
					],
					"role": "stone_dark"
				},
				{
					"shape": "disc",
					"inset": [
						6,
						6,
						6,
						6
					],
					"role": "ash",
					"borderRole": "ash_dark",
					"litRole": "ash_lit"
				},
				{
					"shape": "pipe",
					"from": [
						9,
						21
					],
					"to": [
						23,
						11
					],
					"width": 3,
					"role": "log",
					"litRole": "log_lit"
				},
				{
					"shape": "pipe",
					"from": [
						9,
						11
					],
					"to": [
						23,
						21
					],
					"width": 3,
					"role": "log_dark",
					"litRole": "log"
				},
				{
					"shape": "disc",
					"inset": [
						12,
						12,
						12,
						12
					],
					"role": "ember",
					"borderRole": "none",
					"litRole": "flame_dark"
				},
				{
					"shape": "glyph",
					"id": "flame",
					"at": [
						13,
						11
					],
					"role": "flame",
					"value": "flicker",
					"thresholds": [
						0.3,
						0.7
					],
					"roles": [
						"flame_dark",
						"flame",
						"flame_lit"
					]
				},
				{
					"shape": "lamp",
					"at": [
						14,
						18
					],
					"size": [
						4,
						3
					],
					"value": "flicker",
					"thresholds": [
						0.25,
						0.6
					],
					"roles": [
						"flame_dark",
						"flame",
						"flame_lit"
					],
					"highlight": false
				},
				{
					"shape": "mover",
					"from": [
						15,
						17
					],
					"to": [
						15,
						7
					],
					"value": "flicker",
					"role": "spark",
					"trailRole": "flame_dark",
					"size": [
						1,
						1
					],
					"count": 2,
					"offset": 0.5,
					"wrap": true
				},
				{
					"shape": "mover",
					"from": [
						19,
						18
					],
					"to": [
						18,
						9
					],
					"value": "flicker",
					"role": "spark",
					"trailRole": "none",
					"size": [
						1,
						1
					],
					"count": 1,
					"offset": 0.25,
					"wrap": true
				}
			]
		}
	}
]